import { render, staticRenderFns } from "./TraceabilityDocuments.vue?vue&type=template&id=f0ef3f94&scoped=true&"
import script from "./TraceabilityDocuments.vue?vue&type=script&lang=js&"
export * from "./TraceabilityDocuments.vue?vue&type=script&lang=js&"
import style0 from "./TraceabilityDocuments.vue?vue&type=style&index=0&id=f0ef3f94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0ef3f94",
  null
  
)

export default component.exports